module.exports = __webpack_public_path__ + "assets/image.99c0cc62.svg";